import React from 'react';
import ServiceBg from '../../../../assets/marketing/ServicesBgImg1.webp';

const HeroSection = () => {
	return (
		<div className='w-full h-[400px] sm:h-[400px] h-[300px] mx-[auto] relative mt-[80px]'>
			<img
				src={ServiceBg}
				alt='ServiceBg'
				loading='lazy'
				className='w-full h-full object-cover rounded-none m-[0]'></img>

			<div
				className='absolute bottom-0 mb-[20px] ml-[80px] xl:mb-[30px] 
       tablet:mb-[15px] tablet:ml-[40px]
       mobile:mb-[10px] mobile:ml-[20px]
      '>
				<h1
					className='font-lejour text-[clamp(35px,_3vw,_70px)] font-normal leading-[70px] sm:leading-[70px] leading-[45px] text-left m-0 text-clientWhite
        '>
					Services
				</h1>
				<div className='w-[80%] max-w-[800px] tablet:w-[85%] mobile:w-[95%]'>
					<p
						className='font-glacial text-[20px] font-bold leading-[1.5] text-left m-0 text-clientWhite uppercase
             tablet:text-[15px]
             mobile:text-[14px]'>
						We handle all your marketing needs. Focus on selling properties
						while we deliver results-driven marketing strategies.
					</p>
				</div>
			</div>
		</div>
	);
};

export default HeroSection;
